import { render, staticRenderFns } from "./DecisionAgent.vue?vue&type=template&id=6b278a7f&scoped=true"
import script from "./DecisionAgent.vue?vue&type=script&lang=js"
export * from "./DecisionAgent.vue?vue&type=script&lang=js"
import style0 from "./DecisionAgent.vue?vue&type=style&index=0&id=6b278a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b278a7f",
  null
  
)

export default component.exports